import React from "react";
import { gql } from "__generated__/gql";
import { useApolloClient } from "@apollo/client";
import { Select } from "@cofano/cck";

const UserSelect = ({ value, onChange, multiple }) => {

	const client = useApolloClient();

	const onFetchOptions = async() => {

		const result = await client.query({
			query: LIST_ALL_ACCOUNTS_QUERY,
		});

		return {
			options: result.data.listAllAccounts,
			totalResults: result.data.listAllAccounts.length,
		};
	};

	return (
		<Select
			fetchOptions={onFetchOptions}
			value={value}
			onChange={onChange}
			getOptionLabel={option => option.username}
			multiple={multiple} />
	);
};

const LIST_ALL_ACCOUNTS_QUERY = gql(`#graphql
	query listAllAccounts_userSelect {
		listAllAccounts {
			id
			username
			email
		}
	}
`);

export default UserSelect;
